/* Reviews carousel — mobile only.
   The desktop layout is a plain three-up grid; below 990px the same markup
   becomes a scroll-snap track, so this script only drives the arrows and their
   disabled state. Scrolling itself is native, which keeps swipe behaviour and
   momentum intact on touch. */
(function () {
  function init(root) {
    var track = root.querySelector('[data-kleo-reviews-track]');
    var prev = root.querySelector('[data-kleo-reviews-prev]');
    var next = root.querySelector('[data-kleo-reviews-next]');
    if (!track || !prev || !next || track.dataset.kleoBound === 'true') return;
    track.dataset.kleoBound = 'true';

    function step() {
      var card = track.querySelector('.kleo-lp-review');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      // 2px of slack: sub-pixel scroll positions otherwise leave the end
      // arrow enabled at the last card.
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-kleo-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The theme editor re-renders a section on every settings change.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-kleo-reviews]');
    if (root) init(root);
  });
})();
